module.exports = {"id":"211093","name":"Callum McGregor","rating":"74","photo":"./data/images/photos/1/211093.png","club":{"name":"Celtic","logo":"./data/images/clubs/Celtic.png"},"positions":["MOC","MDC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/CallumMcGregor0.json
// module id = 689
// module chunks = 0